import { render, staticRenderFns } from "./StepOnboarding.vue?vue&type=template&id=9fc4512c"
import script from "./StepOnboarding.vue?vue&type=script&lang=js"
export * from "./StepOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports